import { createSlice } from "@reduxjs/toolkit";
import { getLeads, syncLeads, updateLead, deleteLead } from "./ThunkActions";
import { IFacebookLeadsState, REDUCER_NAME } from "./Types";

const initialState: IFacebookLeadsState = {
  isLoading: false,
  leads: [],
  total: 0,
  page: 1,
  limit: 50,
  errorMessage: null,
  syncLoading: false,
};

const facebookLeadsSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetFacebookLeadsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLeads.pending, (state) => { state.isLoading = true; state.errorMessage = null; })
      .addCase(getLeads.fulfilled, (state, action) => {
        const d = (action.payload as any)?.data?.data;
        state.leads = d?.leads || [];
        state.total = d?.total || 0;
        state.page = d?.page || 1;
        state.limit = d?.limit || 50;
        state.isLoading = false;
      })
      .addCase(getLeads.rejected, (state) => { state.isLoading = false; state.errorMessage = "Failed to fetch leads"; })

      .addCase(syncLeads.pending, (state) => { state.syncLoading = true; })
      .addCase(syncLeads.fulfilled, (state) => { state.syncLoading = false; })
      .addCase(syncLeads.rejected, (state) => { state.syncLoading = false; })

      .addCase(updateLead.fulfilled, (state, action) => {
        const { id, status, notes } = (action.payload as any)?.data || {};
        const lead = state.leads.find((l) => l.id === id);
        if (lead) {
          if (status) lead.status = status;
          if (notes !== undefined) lead.notes = notes;
        }
      })

      .addCase(deleteLead.fulfilled, (state, action) => {
        const { id } = (action.payload as any)?.data || {};
        state.leads = state.leads.filter((l) => l.id !== id);
        state.total = Math.max(0, state.total - 1);
      });
  },
});

export const { resetFacebookLeadsState } = facebookLeadsSlice.actions;
export default facebookLeadsSlice.reducer;
